// export const BASE_URL = window.CONFIG_SERVER_URL
export const BASE_URL = 'http://dev.ubanjiaoyu.com:81/'
// export const BASE_URL = 'http://tcloud.studyo.cn:75/'

export const URL_PATH = `${BASE_URL}`

export const HOST_URL = window.location.host

// 网络请求成功
export const HTTP_SUCCESS = 'success'

export const LOGIN_OUT = 10010

// token过期
export const ERROR_TOKEN = 10000

// eslint-disable-next-line no-extend-native
Date.prototype.Format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S': this.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}




// WEBPACK FOOTER //
// ./src/config/config.js